import { render } from "./PalaceComponent.vue?vue&type=template&id=3ec75edc&scoped=true"
import script from "./PalaceComponent.vue?vue&type=script&lang=js"
export * from "./PalaceComponent.vue?vue&type=script&lang=js"

import "./PalaceComponent.vue?vue&type=style&index=0&id=3ec75edc&scoped=true&lang=css"

import exportComponent from "/root/workspace/web--ming-pan_4MVO/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec75edc"]])

export default __exports__